import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  Text,
  TextProps,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback } from "react";

interface Props extends TextProps {
  trigger: TextProps["children"];
  popoverSize?: PopoverContentProps["w"];
  inverted?: boolean;
}
export function TextPopover({
  children,
  trigger,
  popoverSize = "3xs",
  inverted = false,
  ...textProps
}: React.PropsWithChildren<Props>) {
  const { isOpen, onToggle, onClose } = useDisclosure();

  if (!children) {
    return <>{trigger}</>;
  }

  return (
    <Popover
      closeOnBlur
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      variant="info"
    >
      <PopoverTrigger>
        <Text
          as="span"
          onClick={onToggle}
          textDecorationColor="brand.royalblue.100"
          textDecorationLine="underline"
          textDecorationStyle="dotted"
          textUnderlineOffset={2}
          {...textProps}
        >
          {trigger}
        </Text>
      </PopoverTrigger>
      <PopoverContent
        _focusVisible={{ outline: "none" }}
        bg={inverted ? "brand.white.100" : "brand.black.90"}
        border="none"
        borderRadius={8}
        color={inverted ? "brand.black.90" : "brand.white.100"}
        fontSize="sm"
        p={2}
        w={popoverSize}
      >
        <PopoverArrow bg={inverted ? "brand.white.100" : "brand.black.90"} />
        <span>{children}</span>
      </PopoverContent>
    </Popover>
  );
}
